'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-unused-vars */

/**
 * Abstract Authenticator class.
 * @class Authenticator
 */
function Authenticator() {
  if (!(this instanceof Authenticator)) {
    return new Authenticator();
  }
}

/**
 * initializes the Authenticator
 */
Authenticator.prototype.initialize = function initialize(callback) {};

/**
 * returns the authentication status
 * @abstract
 * @returns {Boolean}
 */
Authenticator.prototype.isAuthenticated = function isAuthenticated() {
  return false;
};

/**
 * check if the user is authenticated
 * @abstract
 * @param {Authenticator~checkAuthenticationCallback} callback -
 *     The callback to be executed when authentication is complete.
 * @returns {Promise.<Boolean>} - A Promise that will be resolved with a Boolean
 * value indicating the authentication status.
 */
Authenticator.prototype.checkAuthentication = function checkAuthentication(callback) {
  throw new Error('checkAuthentication is not implemented.');
};

/**
 * Authenticate the user
 * @abstract
 * @param {Object} identity - The identity to be authenticated.
 * @param {Authenticator~authenticateCallback} callback -
 *     The callback to be executed when authentication is complete.
 * @returns {Promise.<Boolean>} - A Promise that will be resolved with a Boolean
 * value indicating the authentication status.
 */
Authenticator.prototype.authenticate = function authenticate(identity, callback) {
  throw new Error('authenticate is not implemented.');
};

/**
 * Deauthenticate the user
 * @abstract
 * @param {Authenticator~deauthenticateCallback} callback -
 *     The callback to be executed when deauthentication is complete.
 * @returns {Promise.<Boolean>}
 */
Authenticator.prototype.deauthenticate = function deauthenticate(callback) {
  throw new Error('deauthenticate is not implemented.');
};

/**
 * Retrieve the current authentication information.
 * Response will be null if the identity has not be authenticated.
 * @abstract
 * @param {Authenticator~getAuthenticationInfoCallback} callback -
 *     The callback to be executed when the authentication info has been retrieved.
 * @returns {Promise.<Object>}
 */
Authenticator.prototype.getAuthenticationInfo = function getAuthenticationInfo(callback) {
  throw new Error('getAuthenticationInfo is not implemented.');
};

exports.default = Authenticator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/watch-authenticators/build/Authenticator.js
// module id = 211
// module chunks = 1